module.exports = __webpack_public_path__ + "static/img/role-fr.7b30860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/role-fr.png
// module id = NPzh
// module chunks = 1